/**
 * 礼品卡
 */
import $giftcard from '@/api/modules/gift-card'
import { AsyncRequest } from '@/utils/request'
import $moment from 'moment'

const state = {
  cardInfo: {},
  drawInfo: {} // 领取后的信息
}

const getters = {
  cardInfo: state => {
    state.cardInfo.effectiveEndTime = $moment(state.cardInfo.effectiveEndTime).format('YYYY.M.DD HH:mm')
    return state.cardInfo
  },
  drawInfo: state => {
    return state.drawInfo
  }
}

const mutations = {
  giftCardInfo: (state, info) => {
    state.cardInfo = info
  },
  afterDrawInfo: (state, info) => {
    state.drawInfo = info
  }
}

const actions = {
  // 获取列表
  getGiftCardById({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => $giftcard.getGiftCardById(payload),
      resolve: (list) => commit('giftCardInfo', list)
    })
  },
  useGiftCard({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => $giftcard.useGiftCard(payload),
      resolve: (obj) => commit('afterDrawInfo', obj)
    })
  },
  saveCardMessage({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => $giftcard.saveCardMessage(payload)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
